import { render, staticRenderFns } from "./RecurringBalanceInsightPopup.vue?vue&type=template&id=346b9e05&scoped=true"
import script from "./RecurringBalanceInsightPopup.vue?vue&type=script&lang=js"
export * from "./RecurringBalanceInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./RecurringBalanceInsightPopup.vue?vue&type=style&index=0&id=346b9e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b9e05",
  null
  
)

export default component.exports